import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { 
  placeOrderRequest, 
  placeOrderSuccess, 
  placeOrderFailure, 
  fetchPaymentStatusRequest,
  fetchPaymentStatusSuccess,
  fetchPaymentStatusFailure,
  createDeliveryQuoteRequest,
  createDeliveryQuoteSuccess,
  createDeliveryQuoteFailure,
  OrderRequest, 
  OrderResponse,
  PaymentStatusRequest,
  PaymentStatusResponse,
  DeliveryQuoteRequest,
  DeliveryQuoteResponse
} from '../slices/orderSlice';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import { shouldSkipApiCalls } from '../../utils/appConfig';

function* placeOrderSaga(action: PayloadAction<OrderRequest>) {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const response: { data: OrderResponse } = yield call(request, {
      method: 'POST',
      url: ENDPOINTS.PLACE_ORDER_API_PATH,
      data: action.payload,
    });
    
    yield put(placeOrderSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to place order';
    yield put(placeOrderFailure(errorMessage));
  }
}

function* fetchPaymentStatusSaga(action: PayloadAction<PaymentStatusRequest>) {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const response: { data: PaymentStatusResponse } = yield call(request, {
      method: 'GET',
      url: `/pos/order/track?order_id=${action.payload.order_id}`,
      headers: {
        'restaurantId': action.payload.restaurant_id,
      },
    });
    
    yield put(fetchPaymentStatusSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch payment status';
    yield put(fetchPaymentStatusFailure(errorMessage));
  }
}

function* createDeliveryQuoteSaga(action: PayloadAction<DeliveryQuoteRequest>) {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const response: { data: DeliveryQuoteResponse } = yield call(request, {
      method: 'POST',
      url: ENDPOINTS.CREATE_DELIVERY_QUOTE_API_PATH,
      data: action.payload,
      headers: {
        'restaurantId': action.payload.restaurant_id,
      },
    });
    
    yield put(createDeliveryQuoteSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create delivery quote';
    yield put(createDeliveryQuoteFailure(errorMessage));
  }
}

export function* watchOrderSaga() {
  yield takeEvery(placeOrderRequest.type, placeOrderSaga);
  yield takeEvery(fetchPaymentStatusRequest.type, fetchPaymentStatusSaga);
  yield takeEvery(createDeliveryQuoteRequest.type, createDeliveryQuoteSaga);
}
